const strategyTemplatesList = (state) => state.strategyTemplatesList;

const getStrategyTemplateSearchTerm = (state) =>
  state.strategyTemplateSearchTerm;

export default {
  strategyTemplatesList,
  getStrategyTemplateSearchTerm,
};
